import React, { useEffect, useState } from 'react';
import Icon from '@/components/Icon';
import { ApiError, api } from '@/lib/api';

export default function RoomEditModal({ mode, room, onClose, onSaved }) {
  const isEdit = mode === 'edit';

  const [name, setName]               = useState(isEdit ? room.name : '');
  const [description, setDescription] = useState(isEdit ? (room.description || '') : '');
  const [archive, setArchive]         = useState(isEdit ? !!room.archive : false);

  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && !saving) onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose, saving]);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!name.trim()) { setError('Название обязательно'); return; }
    setSaving(true);
    try {
      const payload = {
        name: name.trim(),
        description: description.trim() || null,
        archive,
      };
      const res = isEdit
        ? await api.put('/api/rooms/' + room.id, payload)
        : await api.post('/api/rooms', payload);
      onSaved?.(res.room);
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : (err.message || 'Не удалось сохранить'));
    } finally { setSaving(false); }
  };

  const onDelete = async () => {
    if (!isEdit) return;
    if (!confirm(`Удалить кабинет «${room.name}»?`)) return;
    setSaving(true); setError(null);
    try {
      await api.delete('/api/rooms/' + room.id);
      onSaved?.({ id: room.id, _deleted: true });
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : (err.message || 'Не удалось'));
      setSaving(false);
    }
  };

  return (
    <div className="sd-overlay" onClick={(e) => { if (e.target.classList.contains('sd-overlay') && !saving) onClose(); }}>
      <div className="sd-modal sd-modal--narrow" role="dialog" aria-modal="true">
        <div className="sd-edit__head">
          <h2>{isEdit ? `Кабинет — ${room.name}` : 'Новый кабинет'}</h2>
          <button className="sd-close" onClick={onClose} disabled={saving}><Icon name="x" size={14} /></button>
        </div>
        <form onSubmit={submit} className="sd-edit__form" noValidate>
          <div className="sd-edit__body">
            <div className="sd-edit__field sd-edit__field--full">
              <label className="sd-edit__label">Название *</label>
              <input
                className="sd-edit__input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required autoFocus
                placeholder="105 / Корп. 1, к. 105 / Спортзал"
              />
              <div className="sd-edit__hint">Уникальное имя — отображается в карточке урока и в селектах.</div>
            </div>

            <div className="sd-edit__field sd-edit__field--full">
              <label className="sd-edit__label">Описание</label>
              <input
                className="sd-edit__input"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="напр. для уроков физкультуры"
              />
            </div>

            <div className="sd-edit__field sd-edit__field--full">
              <label className="staff-auth-row">
                <input type="checkbox" checked={archive} onChange={(e) => setArchive(e.target.checked)} />
                <span>В архиве (не показывать в селектах)</span>
              </label>
            </div>
          </div>

          <div className="sd-edit__foot">
            {error && <div className="sd-edit__error">{error}</div>}
            {isEdit && (
              <button type="button" className="btn btn--sm btn--danger" onClick={onDelete} disabled={saving}>Удалить</button>
            )}
            <div className="sd-edit__foot-spacer" />
            <button type="button" className="btn btn--sm" onClick={onClose} disabled={saving}>Отмена</button>
            <button type="submit" className="btn btn--primary btn--sm" disabled={saving}>
              {saving ? 'Сохраняем…' : (isEdit ? 'Сохранить' : 'Создать')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
